import React from "react"; 
import { Link } from "react-router-dom";    
import CategoriesListContent from "../../../components/Dashboard/Categories";

const CategoriesList = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>List of Categories</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Categories List</li>
        </ul>
      </div> */}

      <CategoriesListContent />
    </>
  );
};

export default CategoriesList;
